<template>
  <div>
    <StudentSwitchDropdown
      v-if="showStudentSwitchDropdown"
      @closeStudentSwitchDropdown="closeDropdown"
      @openStudentSwitchDropdown="openStudentSwitchDropdown"
    />
    <UiOnClickOutside :do="closeDropdown">
      <div
        v-if="!tabLeftNav"
        class="xl:mt-6 mt-[15px] flex justify-center cursor-pointer"
        @click="handleDropDown"
      >
        <div
          class="rounded-full min-w-[36px] h-9 lg:w-[54px] lg:h-[54px] lg:min-w-[54px] flex justify-center items-center"
          :class="
            !isAssociatedStudentProfileActive &&
            userRole === TENANT_ROLES.GUARDIAN &&
            currentStudent &&
            'border-[2px] box-content	 border-purple-700'
          "
          @click="toggleDropdown"
        >
          <span
            v-if="!userImage"
            class="bg-primary-purple-200 border-border-color-light border text-primary-purple-600 w-full h-full font-inter text-xs leading-[18px] md:text-sm font-medium sm:text-sm rounded-full uppercase flex justify-center items-center"
          >
            {{ userInitials }}
          </span>
          <span v-else class="min-w-[36px] h-9 lg:w-[54px] lg:h-[54px] lg:min-w-[54px]">
            <img
              class="object-cover h-full w-full z-50 rounded-full"
              :src="userImage"
              alt="user image no found"
            />
          </span>
        </div>
      </div>
      <div
        v-else
        class="flex flex-col gap-2.5 cursor-pointer relative mt-4"
        @click="toggleDropdown"
      >
        <div
          class="flex items-center justify-between w-full bg-[#FFFFFF99]"
          :class="[dropdownContainerClass, dropdownContainerColor]"
        >
          <div class="flex items-center justify-between gap-1 lg:gap-2 truncate">
            <div
              v-if="!isAssociatedStudentProfileActive"
              class="rounded-full min-w-[36px] h-9 lg:w-[54px] lg:h-[54px] lg:min-w-[54px] flex justify-center items-center"
            >
              <!-- * Will enable it when modal fixed -->
              <!-- @click="changeProfilePicture" -->
              <span
                v-if="!userImage"
                class="bg-primary-purple-200 text-primary-purple-600 w-full h-full font-inter text-xs leading-[18px] font-medium sm:text-sm rounded-full uppercase flex justify-center items-center"
              >
                {{ userInitials }}
              </span>
              <span v-else class="w-9 min-w-[36px] h-9 lg:w-[54px] lg:h-[54px] lg:min-w-[54px]">
                <img
                  class="object-cover h-full w-full z-50 rounded-full"
                  :src="userImage"
                  alt="user image no found"
                />
              </span>
            </div>
            <div class="font-inter text-left truncate">
              <div
                class="text-primary-gray-700 text-xs leading-[18px] lg:text-sm font-medium truncate"
              >
                {{ updateNamerange(fullName) }}
              </div>
              <div
                v-if="!isAssociatedStudentProfileActive"
                class="text-primary-gray-400 text-10 lg:text-xs leading-[18px] font-normal truncate"
              >
                <span>{{ currentUserEmail }}</span>
              </div>
            </div>
          </div>
          <div class="ml-1">
            <icon
              :icon="chevronIconDirection"
              :color="chevronIconColor"
              :width="chevronIconWidth"
              :height="chevronIconHeight"
            />
          </div>
        </div>
        <UiMenuDropDown
          class="flex flex-col absolute rounded-tl-lg rounded-tr-lg border-t-[1.5px] bg-primary-purple-50 pt-2.5 w-full border-x-[1.5px] border-b-0 profile-dropdown"
          :class="dropdownContainerColor"
          :is-open="isOpen"
          :disabled-styles="true"
          @toggle-is-open="toggleIsOpen"
        >
          <ul
            class="flex flex-col gap-[15px] px-2.5 pt-[15px] font-inter font-normal text-primary-gray-700 text-sm border-b-primary-purple-100 border-b pb-2.5"
          >
            <li
              v-if="isControlPanelVisible"
              class="flex gap-1.5 md:gap-2 items-center text-xs leading-[18px] md:text-sm font-medium text-primary-gray-700"
              @mouseover="profileActionMouseOver(1)"
              @mouseleave="profileActionMouseleave()"
              @click="handleDropDown()"
            >
              <span class="h-6 w-6 flex items-center justify-center">
                <icon
                  icon="controlPanel"
                  :color="profileActionIconColorClass(1)"
                  :width="iconWidth"
                  :height="iconHeight"
                />
              </span>
              <router-link to="/control-panel/settings">
                <a>
                  <span
                    v-i18n="header"
                    class="w-full"
                    :class="{ 'text-primary-purple-700': profileActionIconColor === 1 }"
                  >
                    Control Panel
                  </span>
                </a>
              </router-link>
            </li>
            <li
              class="flex gap-1.5 md:gap-2 items-center text-xs leading-[18px] md:text-sm font-medium text-primary-gray-700"
              @mouseover="profileActionMouseOver(2)"
              @mouseleave="profileActionMouseleave()"
              @click="handleDropDown()"
            >
              <span class="h-6 w-6 flex items-center justify-center">
                <icon
                  icon="personalSetting"
                  :color="profileActionIconColorClass(2)"
                  :width="iconWidth"
                  :height="iconHeight"
                />
              </span>
              <router-link to="/settings/user">
                <a>
                  <span
                    v-i18n="header"
                    class="w-full"
                    :class="{ 'text-primary-purple-700': profileActionIconColor === 2 }"
                  >
                    Personal Settings
                  </span>
                </a>
              </router-link>
            </li>
            <li
              v-permission="salaryTabPermissions"
              class="flex gap-1.5 md:gap-2 items-center text-xs leading-[18px] md:text-sm font-medium text-primary-gray-700"
              @mouseover="profileActionMouseOver(3)"
              @mouseleave="profileActionMouseleave()"
              @click="handleDropDown()"
            >
              <span class="h-6 w-6 flex items-center justify-center">
                <icon
                  height="14"
                  width="14"
                  icon="history"
                  :color="profileActionIconColorClass(3)"
                />
              </span>
              <router-link to="/salary-manager/my-salary">
                <a>
                  <span
                    v-i18n="header"
                    class="w-full"
                    :class="{ 'text-primary-purple-700': profileActionIconColor === 3 }"
                  >
                    MY_SALARY
                  </span>
                </a>
              </router-link>
            </li>
            <!-- *Comment it till personal settings implemented -->
            <!-- <li
              v-permission="personalSettingsPerission"
              class="flex gap-2 items-center text-sm font-medium text-primary-gray-700"
              @mouseover="profileActionMouseOver()"
              @mouseleave="profileActionMouseleave()"
            >
              <span class="h-6 w-6 flex items-center justify-center">
                <icon height="16" width="16" icon="AppDoc" color="menu" />
              </span>
              <router-link to="/app-documentation">
                <a>
                  <span
                    v-i18n="header"
                    class="w-full"
                    :class="{ 'text-primary-purple-700': profileActionIconColor }"
                  >
                    APP_DOCUMENT
                  </span>
                </a>
              </router-link>
            </li> -->
            <li
              class="flex gap-1.5 md:gap-2 items-center text-xs leading-[18px] md:text-sm font-medium text-primary-gray-700"
              @mouseover="profileActionMouseOver(7)"
              @mouseleave="profileActionMouseleave()"
            >
              <span class="h-6 w-6 flex items-center justify-center">
                <icon
                  icon="logout"
                  :color="profileActionIconColorClass(7)"
                  :width="iconWidth"
                  :height="iconHeight"
                />
              </span>
              <span
                v-i18n="header"
                class="w-full"
                :class="{ 'text-primary-purple-700': profileActionIconColor === 7 }"
                @click="signOut"
              >
                Sign Out
              </span>
            </li>
          </ul>
        </UiMenuDropDown>
      </div>
    </UiOnClickOutside>
    <UserRoleSwitch v-show="isRoleSwitchVisible" ref="gaurdianRoleSwitch" />

    <!-- Image modal -->
    <ValidationObserver @submit="uploadPicture">
      <UiModalContainer
        v-if="showProfileModal"
        footer-classes="flex justify-end"
        :modal-show="showProfileModal"
        :disable-position-center="true"
        modal-classes="mt-44"
        @handleClick="handleClick"
      >
        <template v-slot:header>
          <div class="flex rtl:flex-row-reverse">
            <span v-i18n="dashboard">Change Image</span>
          </div>
        </template>
        <template v-slot>
          <div
            class="items-center my-6 max-w-min lg:max-w-screen-lg md:max-w-screen-sm overflow-x-scroll px-8"
          >
            <div class="upload-block my-5">
              <div class="flex flex-col justify-center gap-2 mt-2">
                <Field as="div" class="input-field w-100" name="file">
                  <input
                    id="img-btn"
                    ref="imgUpload"
                    type="file"
                    class="input-field w-100"
                    hidden
                    rules="imageRules"
                    name="file"
                    accept="image/png, image/jpeg, image/jpg"
                    @input="changeImage"
                  />
                </Field>

                <div ref="errorContainer" class="flex justify-end h-5">
                  <ErrorMessage v-slot="{ message }" :name="name === '' ? title : name">
                    <small
                      class="error-msg text-sm text-text-color-danger italic rtl:mt-1 ltr:-mt-0"
                    >
                      <p>{{ message }}</p>
                    </small>
                  </ErrorMessage>
                </div>
                <label
                  for="img-btn"
                  class="flex w-56 cursor-pointer border border-primary-green justify-center items-center px-2 sm:px-5 py-2 rounded-sm"
                >
                  <span>
                    <icon
                      class="icon ltr:mr-2 rtl:ml-2"
                      icon="cloudUpload"
                      color="primary-green"
                      height="20"
                      width="20"
                    />
                  </span>
                  <span
                    v-i18n="dashboard"
                    class="font-roboto font-normal text-xs sm:text-base text-menu"
                  >
                    Choose File
                  </span>
                </label>
                <span
                  v-i18n="dashboard"
                  class="font-roboto font-normal text-xs sm:text-sm text-text-color"
                >
                  ALLOWED_TYPE_OF_IMAGE
                </span>
              </div>
              <span v-if="image.name !== ''" class="mt-2 font-roboto font-normal text-sm">
                {{ image.name }}
              </span>
              <img v-if="image.url" :src="image.url" alt="" srcset="" width="300" height="300" />
            </div>
          </div>
        </template>
        <template v-slot:footer>
          <div class="flex gap-3 rtl:gap-x-4">
            <UIButton @click="handleClick('close')">Cancel</UIButton>
            <UIButton button="primary">
              <template v-if="imageUploading">
                <Loader />
              </template>
              <template v-else>
                <span>Save</span>
              </template>
            </UIButton>
          </div>
        </template>
      </UiModalContainer>
    </ValidationObserver>
    <teleport to="body">
      <PWAGuideLinesModal :show-model="showPwaModal" @handleClick="hidePwaModel" />
    </teleport>
  </div>
</template>

<script>
import UserRoleSwitch from '@src/modules/header/UserRoleSwitch.vue'
import UiOnClickOutside from '@components/UiElements/UiOnClickOutside.vue'
import UiMenuDropDown from '@components/UiElements/UiMenuDropDown.vue'
import { mapActions, mapGetters, mapState } from 'vuex'
import UiModalContainer from '@components/UiElements/UiModalContainer.vue'
import icon from '@components/icons/icon.vue'
import Loader from '@components/BaseComponent/Loader.vue'
import { Form as ValidationObserver } from 'vee-validate'
import RULE_CONSTANTS from '@src/constants/rule.constants.js'
import AuthMixins from '@src/mixins/auth-mixin.js'
import setPWA, { isPWARunning } from '../../utils/pwa-utils'
import PWAGuideLinesModal from '@components/pwa/PWAGuideLinesModal.vue'
import StudentSwitchDropdown from '@src/modules/header/student-switch-dropdown/StudentSwitchDropdown.vue'
import { Field, configure, ErrorMessage } from 'vee-validate'
import { validationConfiguration } from '@src/vee-validate/index.js'
import UIButton from '@src/components/UiElements/UIButton.vue'
import { TENANT_ROLES } from '@src/constants/user-roles-constants.js'
import { PWA_HARD_RELOAD_TIMEOUT } from '@src/constants/layout-constant.js'
import { getTimeInMs } from '@utils/generalUtil.js'
configure(validationConfiguration)
import { ENV } from '@src/constants/general-constants.js'
export default {
  components: {
    UiOnClickOutside,
    UiMenuDropDown,
    ErrorMessage,
    Field,
    UiModalContainer,
    icon,
    Loader,
    ValidationObserver,
    UIButton,
    UserRoleSwitch,
    PWAGuideLinesModal,
    StudentSwitchDropdown,
  },
  mixins: [AuthMixins],
  data() {
    return {
      redirectTo: localStorage.getItem('redirectTo'),
      TENANT_ROLES,
      salaryTabPermissions: {
        env: ['local'],
        roles: ['campus_admin', 'section_teacher', 'staff'],
      },
      PERSONAL_SETTINGS_PERMISSION: {
        env: [ENV.DEV],
      },
      isOpenStudentSwitchDropdown: false,
      isActive: false,
      isRoleSwitchVisible: false,
      get currentStudent() {
        return JSON.parse(localStorage.getItem('currentActiveStudent'))
      },
      set currentStudent(value) {
        JSON.parse(localStorage.getItem('currentActiveStudent'))
      },
      isOpen: false,
      dashboard: 'dashboard',
      header: 'header',
      showProfileModal: false,
      imageUploading: false,
      image: {
        name: '',
        url: null,
      },
      showPwaModal: false,
      personalSettingsPerission: {
        env: ['local'],
      },
      profileActionIconColor: null,
      iconWidth: '24',
      iconHeight: '24',
    }
  },
  computed: {
    ...mapState({
      activeRole: (state) => state.layout.activeRole,
      tabLeftNav: (state) => state?.layout?.tabLeftNav,
      activeStudent: (state) => state.student.activeStudent,
      currentCampusScope: (state) => state.layout.currentCampusScope,
      currentSectionScope: (state) => state.layout.currentSectionScope,
      isAssociatedStudentProfileActive: (state) => state.layout.isAssociatedStudentProfileActive,
      isTabView: (state) => state.layout.isTabView,
    }),
    showStudentSwitchDropdown() {
      if (this.activeStudent && this.currentStudent) {
        return true
      }
      return false
    },
    profileActionIconColorClass() {
      return (index) => {
        return this.profileActionIconColor === index ? 'primary-purple-700' : 'primary-gray-700'
      }
    },
    chevronIconColor() {
      return this.isActive ? 'primary-purple-700' : 'primary-gray-700'
    },
    chevronIconDirection() {
      let res
      if (!this.isActive) {
        if (this.isAssociatedStudentProfileActive) {
          res = 'expandCollapse'
        } else {
          res = 'chevronBottom'
        }
      } else {
        res = 'chevronUp'
      }
      return res
    },
    chevronIconWidth() {
      return !this.isAssociatedStudentProfileActive ? '12' : '15'
    },
    chevronIconHeight() {
      return !this.isAssociatedStudentProfileActive ? '6' : '15'
    },
    dropdownContainerClass() {
      return this.isActive
        ? 'border-t-0 border-[1.5px] border-x border-b rounded-bl-lg rounded-br-lg bg-primary-purple-50 p-2.5'
        : 'border-[1.5px] border rounded-lg p-2.5'
    },
    dropdownContainerColor() {
      let currentLoginUserActive =
        this.userRole === TENANT_ROLES.GUARDIAN &&
        !this.isAssociatedStudentProfileActive &&
        this.currentStudent
      return currentLoginUserActive ? 'border-purple-700' : 'border-white'
    },
    isPicker() {
      return ['guardian'].includes(this.userRole)
    },
    isPickupSupportPerson() {
      return ['section_teacher', 'staff'].includes(this.userRole)
    },
    myProfilePermissions() {
      let isAllowed = {
        roles: [
          TENANT_ROLES.SUPER_ADMIN,
          TENANT_ROLES.SECTION_TEACHER,
          TENANT_ROLES.SECTION_STUDENT,
          TENANT_ROLES.GUARDIAN,
          TENANT_ROLES.CAMPUS_ADMIN,
          TENANT_ROLES.PICKUP_PERSON,
        ],
      }
      return isAllowed
    },
    isMyScheduleEnabled() {
      if (!this.selectedCampusId) return false
      if ([].includes(this.userRole)) return true
      return false
    },
    isControlPanelVisible() {
      return ['super_admin', 'campus_admin'].includes(this.userRole)
    },
    imageRules() {
      return `required|${RULE_CONSTANTS.SIZE}`
    },
    userInitials() {
      return this.nameInitials && this.nameInitials !== '0' && this.nameInitials
    },
    ...mapGetters('auth', [
      'fullName',
      'userImage',
      'nameInitials',
      'currentUserId',
      'currentUserEmail',
    ]),
    ...mapGetters('layout', ['selectedCampusId', 'userRole']),
  },
  mounted() {
    window.addEventListener('resize', this.updateIconSize)
    this.updateIconSize()
    this.checkPWAInstallationOnLoad()
  },
  beforeUnmount() {
    window.removeEventListener('resize', this.updateIconSize)
  },
  methods: {
    handleDropDown() {
      if (this.isTabView) {
        this.$store.commit('layout/SET_TAB_LEFT_BAR', false)
      }
      this.closeDropdown()
    },
    isPWARunning,
    openStudentSwitchDropdown(payload) {
      this.isOpenStudentSwitchDropdown = payload
    },

    updateIconSize() {
      if (this.isTabView) {
        this.iconWidth = '20'
        this.iconHeight = '20'
      } else {
        this.iconWidth = '24'
        this.iconHeight = '24'
      }
    },
    profileActionMouseOver(index) {
      this.profileActionIconColor = index
    },
    profileActionMouseleave() {
      this.profileActionIconColor = null
    },
    updateNamerange(name) {
      if (name.length > 12) {
        return `${name.slice(0, 12)}...`
      } else {
        return name
      }
    },
    toggleDropdown() {
      this.isActive = !this.isActive
      if (this.isAssociatedStudentProfileActive) {
        this.$store.commit('layout/SET_GUARDIAN_AND_STUDENT_PROFILES', false)
        if (
          this.currentStudent &&
          [
            TENANT_ROLES.SUPER_ADMIN,
            TENANT_ROLES.CAMPUS_ADMIN,
            TENANT_ROLES.SECTION_TEACHER,
          ].includes(this.activeRole)
        ) {
          this.$store.commit('student/SET_ACTIVE_STUDENT', false)
          this.$router.push({ name: this.redirectTo })
          this.closeDropdown()
        } else {
          this.$refs['gaurdianRoleSwitch']?.switchRoles(this.activeRole, false, false)
        }
      }
      this.profileActionIconColor = null
      this.toggleIsOpen()
    },
    toggleIsOpen(value) {
      this.isOpen = typeof value === 'boolean' ? value : !this.isOpen
    },
    closeDropdown() {
      if (this.isActive) {
        this.isActive = false
        this.profileActionIconColor = null
        this.toggleIsOpen()
      }
    },
    closeStudentDropdown() {
      this.isOpenStudentSwitchDropdown = false
    },
    changeProfilePicture() {
      this.showProfileModal = !this.showProfileModal
    },
    handleClick(eventName) {
      switch (eventName) {
        case 'close':
          this.showProfileModal = false
          this.image = {
            name: '',
            url: null,
          }
          this.$refs['img-upload'].value = null
          break
        case 'cancel':
          break
        case 'save':
          break
      }
    },
    uploadPicture() {
      this.imageUploading = true
      const data = new FormData()
      data.append('user_id', this.currentUserId)
      data.append('files[]', this.$refs['img-upload'].files[0])
      this.uploadUserImage(data)
        .then((response) => {
          this.$store.commit('auth/CHANGE_CURRENT_USER_IAMGE', response[0].url)
          this.showProfileModal = false
          this.imageUploading = false
          this.image = {
            name: '',
            url: null,
          }
        })
        .finally(() => {
          this.imageUploading = false
        })
    },
    changeImage(event) {
      const input = this.$refs.imgUpload
      const file = input.files
      if (file && file[0]) {
        const reader = new FileReader()
        reader.onload = (event) => {
          this.image.url = event.target.result
          this.image.fileName = file[0].name
        }
        reader.readAsDataURL(file[0])
      }
    },
    checkPWAInstallationOnLoad() {
      const nextCheck = localStorage.getItem('pwaNextCheck')
      const now = Date.now()
      const twentyFourHours = getTimeInMs(24, 'h')
      if (nextCheck && now < parseInt(nextCheck)) return
      localStorage.setItem('pwaNextCheck', (now + twentyFourHours).toString())
      if (!isPWARunning()) {
        this.installPWA()
      }
    },
    installPWA() {
      setPWA()
      const promptEvent = window.deferredPrompt
      if (!promptEvent) {
        this.showPwaModal = true
        return
      }
      promptEvent.prompt()
      promptEvent.userChoice.then((choiceResult) => {
        window.deferredPrompt = null
        if (choiceResult.outcome === 'accepted') {
          setTimeout(() => {
            window.location.reload(true)
          }, PWA_HARD_RELOAD_TIMEOUT)
        }
      })
    },
    hidePwaModel(eventName) {
      this.showPwaModal = false
    },
    ...mapActions('users', ['uploadUserImage']),
  },
}
</script>

<style lang="scss" scoped>
.profile-dropdown {
  bottom: 56px;
}
@media screen and (min-width: 1024px) {
  .profile-dropdown {
    bottom: 74px;
  }
}
</style>
